// Bootstrap
require('./bootstrap.js');
require('../../../node_modules/bootstrap-select/dist/js/bootstrap-select');

require('./layouts/navbar.js');
